import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { PatientService } from '../services/patient/patient.service';
import { RegistrationStateService } from '../pages/registration/registration-state.service';
import { SettingsService } from '../services/settings.service';
import { AuthService } from '../services/auth.service';

export const registrationGuard: CanActivateFn = (route, state) => {
    const patientService = inject(PatientService);
    const registrationStateService = inject(RegistrationStateService);
    const settingsService = inject(SettingsService);
    const authService = inject(AuthService);
    const router = inject(Router);
    const status = patientService.getRegistrationStatus();
    
    if (!authService.isAuthenticated()) {
        console.log('Registration: User not authenticated, redirecting to home page')
        return false;
    }  

    if (status === 'REJECTED') {
        const registrationData = registrationStateService.getRegistrationData();
        console.log(registrationData)
        if (!registrationData || Object.keys(registrationData).length === 0) {
            console.log('Registration: Status is REJECTED and no registration data, redirecting to login')
            router.navigate(['/login']);
            return false;
        }
        return true;
    }
    
    if (status === 'UNREGISTERED') {
        console.log('Registration: Status is UNREGISTERED, allowing access to registration page')
        return true;
    }
    
    if (status === 'REGISTERED' || status === 'PENDING') {
        console.log('Registration: Status is registered or pending, redirecting to dashboard')
        router.navigate(['/dashboard']);
    } else {
        console.log('Registration: Status is registered or pending, redirecting to dashboard')
        router.navigate(['/login']);
    }
  
    return false;
};
